import {
    FETCH_INTEGRATION_REQUESTED,
    FETCH_INTEGRATION_SUCCESS,
    FETCH_INTEGRATION_FAILURE,
    CREATE_INTEGRATION_REQUESTED,
    CREATE_INTEGRATION_SUCCESS,
    CREATE_INTEGRATION_FAILURE,
    SET_DEFAULT_AUDIO_PROFILE,
    UPDATE_PRONUNCIATION_LIBRARY
} from "../actionTypes"

export const fetchIntegrationRequested = (org_id, id) => {
    return {
        type: FETCH_INTEGRATION_REQUESTED,
        payload: {org_id, id},
    };
};

export const fetchIntegrationSuccess = (data) => {
    return {
        type: FETCH_INTEGRATION_SUCCESS,
        payload: data,
    };
};

export const fetchIntegrationFailure = (data) => {
    return {
        type: FETCH_INTEGRATION_FAILURE,
        payload: data,
    };
};

export const createIntegrationRequested = (org_id, body) => {
    return {
        type: CREATE_INTEGRATION_REQUESTED,
        payload: {org_id, body},
    };
};

export const createIntegrationSuccess = (data) => {
    return {
        type: CREATE_INTEGRATION_SUCCESS,
        payload: data,
    };
};

export const createIntegrationFailure = (data) => {
    return {
        type: CREATE_INTEGRATION_FAILURE,
        payload: data,
    };
};

// ✨ Profile actions removed - migrated to React Query hooks:
// - fetchIntegrationProfilesRequested → useSavedProfiles
// - fetchIntegrationProfilesSuccess → (handled by React Query)
// - fetchIntegrationProfilesFailure → (handled by React Query)
// - deleteAudioProfileRequested → useDeleteProfile
// - deleteAudioProfileSuccess → (handled by React Query)
// - deleteAudioProfileFailure → (handled by React Query)

export const updateDefaultAudioProfile = (data) => {
    return {
        type : SET_DEFAULT_AUDIO_PROFILE,
        payload : data
    }
}

export const updatePronunciationLibrary = (data) => {
    return {
        type: UPDATE_PRONUNCIATION_LIBRARY,
        payload: data,
    }
}